<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
  flat
  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.timer = null;
    this.requestSeq = 0;
    this.unmounted = false;

    GeocoderFactory().then(geocoder => {
      if (!this.unmounted) {
        this.geocoder = geocoder;
      }
    });
  },

  beforeDestroy() {
    this.unmounted = true;
    this.invalidate();
  },

  watch: {
    search(val) {
      if (!val || !String(val).trim()) {
        this.invalidate();
        this.items = [];
        return;
      }

      if (this.select && typeof this.select === "object" && val === this.select.text) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage; verspätete Antworten werden verworfen
    invalidate() {
      this.requestSeq++;

      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.invalidate();

      if (!this.geocoder) {
        return;
      }

      const seq = this.requestSeq;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        if (seq !== this.requestSeq || !this.geocoder) {
          return;
        }

        this.geocoder.autocomplete(value).then(items => {
          if (seq !== this.requestSeq) {
            return;
          }

          this.items = items.slice();
        }).finally(() => {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
        });
      }, DEBOUNCE);
    },

    change(o) {
      this.invalidate();
      this.$emit("change", o);
    }
  }
};
</script>
